import { css } from 'styled-components'

/**
 * https://app.zeplin.io/project/5b71e2295bde783107ce2133/screen/5b71e267277f0d5b80d84c58
 *
 * Typographic units defined in document:
 *    family-xx
 *    fsize-xx (a.k.a. f-size-xx or just XXpx in certain cases)
 *
 * The document further aliases a few things:
 *    (XXpx) -> f-size-yy
 *    (Aspira .*) -> family-xx
 *
 * We alias font sizes thusly:
 *    (XXpx) -> FontSizeXX
 */

export const AspiraStack = css`
  font-family: 'Aspira Webfont', Aspira, Helvetica, Arimo, 'Liberation Sans', Arial,
    sans-serif;
`

export const TimesNewRomanStack = css`
  font-family: 'Times New Roman', Tinos, 'Liberation Serif', serif;
`

export const weights = {
  regular: 'normal',
  light: '300',
  medium: '500',
  bold: 'bold',
}

export const Family01 = css`
  ${AspiraStack};
  font-weight: ${weights.regular};
`

export const AspiraRegular = Family01

export const Family02 = css`
  ${AspiraStack};
  font-weight: ${weights.light};
`

export const AspiraLight = Family02

export const Family03 = css`
  ${AspiraStack};
  font-weight: ${weights.medium};
`

export const AspiraMedium = Family03

export const Family04 = css`
  ${AspiraStack};
  font-weight: ${weights.bold};
`

export const AspiraBold = Family04

// TODO: Switch fontSize values back to rem after legacy CSS has been fully deprecated
// rem values are calculated assuming 16px default font-size (common amongst most browsers)
export const sizes = {
  fSize01: {
    fontSize: '11px', // '0.6875rem',
    lineHeight: '1.454545454545', // 16px
  },
  fSize02: {
    fontSize: '12px', // '0.75rem',
    lineHeight: '1.5', // 18px
  },
  fSize03: {
    fontSize: '14px', // '0.875rem',
    lineHeight: '1.5', // 21px
  },
  fSize03b: {
    fontSize: '16px', // '1rem',
    lineHeight: '1.5', // 24px
  },
  fSize04: {
    fontSize: '18px', // '1.125rem',
    lineHeight: '1.333333333333', // 24px
  },
  fSize05: {
    fontSize: '20px', // '1.25rem',
    lineHeight: '1.3', // 26px
  },
  fSize06: {
    fontSize: '24px', // '1.5rem',
    lineHeight: '1.333333333333', // 32px
  },
  fSize07: {
    fontSize: '28px', // '1.75rem',
    lineHeight: '1.285714285714', // 36px
  },
  fSize08: {
    fontSize: '34px', // '2.125rem',
    lineHeight: '1.294117647058', // 44px
  },
  fSize09: {
    fontSize: '48px', // '3rem',
    lineHeight: '1.166666666666', // 56px
  },
}

export const FontSize11 = css`
  font-size: ${sizes.fSize01.fontSize};
  line-height: ${sizes.fSize01.lineHeight};
`

export const FontSize12 = css`
  font-size: ${sizes.fSize02.fontSize};
  line-height: ${sizes.fSize02.lineHeight};
`

export const FontSize14 = css`
  font-size: ${sizes.fSize03.fontSize};
  line-height: ${sizes.fSize03.lineHeight};
`

export const FontSize16 = css`
  font-size: ${sizes.fSize03b.fontSize};
  line-height: ${sizes.fSize03b.lineHeight};
`

export const FontSize18 = css`
  font-size: ${sizes.fSize04.fontSize};
  line-height: ${sizes.fSize04.lineHeight};
`

export const FontSize20 = css`
  font-size: ${sizes.fSize05.fontSize};
  line-height: ${sizes.fSize05.lineHeight};
`

export const FontSize24 = css`
  font-size: ${sizes.fSize06.fontSize};
  line-height: ${sizes.fSize06.lineHeight};
`

export const FontSize28 = css`
  font-size: ${sizes.fSize07.fontSize};
  line-height: ${sizes.fSize07.lineHeight};
`

export const FontSize34 = css`
  font-size: ${sizes.fSize08.fontSize};
  line-height: ${sizes.fSize08.lineHeight};
`

export const FontSize48 = css`
  font-size: ${sizes.fSize09.fontSize};
  line-height: ${sizes.fSize09.lineHeight};
`
